<template>
  <div
    v-infinite-scroll="load"
    infinite-scroll-disabled="disabled"
    style="height: 400px;width: 100%;overflow:auto"
  >
    <el-card
      @click.native.stop="cardClick(item, index)"
      :class="{ noticePanel: item.active }"
      v-for="(item, index) in normalNoticeSource"
      :key="index"
    >
      <div style="float:right; cursor:pointer" @click="readRemind(item)">
        <el-tooltip :content="item.ISREAD ? '已读' : '未读'" placement="bottom" effect="light">
          <icon :iconClass="item.ISREAD ? 'yidu' : 'xin-copy'" iconStyle="readIcon"></icon>
        </el-tooltip>
      </div>
      <div class="detailPanel">
        <div class="nameImg">
          <icon :iconClass="getIcon(item.INFOTYPE)" iconStyle="avatarIcon"></icon>
        </div>
        <div>
          <div style="display:flex;flex-wrap: wrap;">
            <el-link class="linkName" :underline="false" @click.native.stop="clickAddress(item)">
              <span>【{{ item.NAME }}】</span>
            </el-link>
            <span class="title">{{ item.CREATEUSERNAME}}给您发送了一条通知，请注意查收</span>
          </div>
          <el-tooltip :content="item.CONTENT" placement="bottom" effect="light">
            <div class="content">{{ item.CONTENT }}</div>
          </el-tooltip>
          <div class="createTime">{{ item.CREATETIME | timeFormater }}</div>
          <span
            class="reply"
            style="cursor:Pointer"
            @click="reply(item)"
          >{{item.RELATIONID.split("_")[1]==1?'回复':''}}</span>
        </div>
      </div>
    </el-card>
    <h3 v-if="loading">加载中...</h3>
    <h3 v-if="noMore">没有更多了</h3>
  </div>
</template>

<script>
import { GetUnReadRemind } from "@/api/modules/basicData/task";
import { getToken } from "@/util/auth";
import icon from "@/components/common/icon.vue";
import Vue from "vue";
const cookieUser = getToken();
export default {
  components: {
    icon,
  },
  props: {
    normalNoticeSource: {
      type: Array,
      default: () => [],
    },
    normalCount: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    noMore() {
      return this.normalCount <= this.pageIndex * this.pageSize;
    },
    disabled() {
      return this.loading || this.noMore;
    },
  },
  data() {
    return {
      loading: false,
      replyData: {},
      curItem: null,
      iconClasses: [
        "icon iconfont icon-guanzhu2",
        "icon iconfont icon-guanzhu2",
        "icon iconfont icon-guanzhu2",
      ],
      mainId: "",
      mainType: "1",
      avatarArray: ["tonggao"],
      pageIndex: 1,
      pageSize: 10,
    };
  },
  mounted() {
    this._getUnReadRemind();
  },
  methods: {
    load() {
      if (this.noMore) return;
      this.pageIndex++;
      this._getUnReadRemind();
    },
    _getUnReadRemind() {
      this.loading = true;
      GetUnReadRemind(this.pageIndex, this.pageSize, cookieUser.userId, 1)
        .then((result) => {
          console.log("GetUnReadRemind", result);
          if (result.Items) {
            this.loading = false;
            this.$emit("refershNormalSource", result);
          }
        })
        .catch((err) => console.log(err));
    },
    readRemind(item) {
      this.$emit("readRemind", item);
    },
    cardClick(item, index) {
      this.curItem = item;
      console.log(item.INFOTYPE);
      console.log("cardClick", index);
      this.$nextTick(() => {
        this.normalNoticeSource.forEach((o) => {
          this.$set(o, "active", false);
        });
        this.$set(item, "active", true);
      });
    },

    getIcon(infotype) {
      switch (infotype) {
        default:
          return this.avatarArray[0];
      }
    },
    reply(data) {},

    clickAddress(item) {
      if (!item.ISREAD) {
        this.readRemind(item);
      }
      switch (item.INFOTYPE) {
        case 23: //通知通告
        default:
          if (item.RELATIONID) {
            console.log("RELATIONID", item.RELATIONID);
            let arr = item.RELATIONID.split("_");
            let indexType = arr[1];
            let url2 = `${location.href.substr(
              0,
              location.href.lastIndexOf("/")
            )}/notificationLookOver/${arr[0]}/${indexType}`;
            if (indexType == 1) {
              url2 = `${url2}/${item.ID}`;
            } else {
              url2 = `${url2}/0`;
            }
            window.open(url2);
          }
          break;
      }
    },
  },
};
</script>
<style scoped>
.avatarIcon {
  width: 24px;
  height: 24px;
  margin-top: 10px;
}
.noticePanel {
  /* box-shadow: 0 2px 12px 0 rgb(32, 179, 45, 0.4); */
  border: 1px dashed gray;
}
.readIcon {
  width: 24px;
  height: 24px;
}

.detailPanel {
  display: flex;
  background: white /*beige*/;
  font-size: 14px;
}

.nameImg {
  color: #0c9cdb !important;
  margin-right: 5px;
}

.linkName {
  color: #0c9cdb !important;
}

.reply {
  margin-left: 15px;
  color: #0c9cdb !important;
}

.content {
  color: #20b32d;
  margin-left: 6px;
  max-width: 500px;
  overflow: hidden;
  /*超过部分不显示*/
  text-overflow: ellipsis;
  /*超过部分用点点表示*/
  white-space: nowrap;
  /*不换行*/
  text-align: left;
}

.createTime {
  font-size: 10px;
  color: #999;
  margin: 2px 6px;
  float: left;
}
</style>
